import actions from './actions';

const {
  POST_PROCESS_DOCUMET_BEGIN,
  POST_PROCESS_DOCUMET_SUCCESS,
  POST_PROCESS_DOCUMET_ERROR,

  GET_DOCUMENT_BY_ID_BEGIN,
  GET_DOCUMENT_BY_ID_SUCCESS,
  GET_DOCUMENT_BY_ID_ERROR,

  GET_LOG_BY_DOCUMENT_ID_BEGIN,
  GET_LOG_BY_DOCUMENT_ID_SUCCESS,
  GET_LOG_BY_DOCUMENT_ID_ERROR,

  GET_PDF_BY_DOCUMENT_ID_BEGIN,
  GET_PDF_BY_DOCUMENT_ID_SUCCESS,
  GET_PDF_BY_DOCUMENT_ID_ERROR,

  POST_REVALIDATE_DOCUMENT_BEGIN,
  POST_REVALIDATE_DOCUMENT_SUCCESS,
  POST_REVALIDATE_DOCUMENT_ERROR,

  PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_BEGIN,
  PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_SUCCESS,
  PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_ERROR,

  GET_ALLOWED_DOCUMENT_TYPES_BEGIN,
  GET_ALLOWED_DOCUMENT_TYPES_SUCCESS,
  GET_ALLOWED_DOCUMENT_TYPES_ERROR,

  GET_DOCUMENT_ORDERS_BEGIN,
  GET_DOCUMENT_ORDERS_SUCCESS,
  GET_DOCUMENT_ORDERS_ERROR,

  GET_DOCUMENT_ORDERS_BY_IDS_BEGIN,
  GET_DOCUMENT_ORDERS_BY_IDS_SUCCESS,
  GET_DOCUMENT_ORDERS_BY_IDS_ERROR,

  POST_UPDATE_ORDERS_BEGIN,
  POST_UPDATE_ORDERS_SUCCESS,
  POST_UPDATE_ORDERS_ERROR,
} = actions;

const initState = {
  loading: false,
  error: null,
};

const aiReducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case POST_PROCESS_DOCUMET_BEGIN:
    case POST_PROCESS_DOCUMET_SUCCESS:
    // fall through
    case GET_DOCUMENT_BY_ID_BEGIN:
    case GET_DOCUMENT_BY_ID_SUCCESS:
    // fall through
    case GET_LOG_BY_DOCUMENT_ID_BEGIN:
    case GET_LOG_BY_DOCUMENT_ID_SUCCESS:
    // fall through
    case GET_PDF_BY_DOCUMENT_ID_BEGIN:
    case GET_PDF_BY_DOCUMENT_ID_SUCCESS:
    // fall through
    case POST_REVALIDATE_DOCUMENT_BEGIN:
    case POST_REVALIDATE_DOCUMENT_SUCCESS:
    // fall through
    case PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_BEGIN:
    case PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_SUCCESS:
    // fall through
    case GET_ALLOWED_DOCUMENT_TYPES_BEGIN:
    case GET_ALLOWED_DOCUMENT_TYPES_SUCCESS:
    // fall through
    case GET_DOCUMENT_ORDERS_BEGIN:
    case GET_DOCUMENT_ORDERS_SUCCESS:
    // fall through
    case GET_DOCUMENT_ORDERS_BY_IDS_BEGIN:
    case GET_DOCUMENT_ORDERS_BY_IDS_SUCCESS:
    // fall through
    case POST_UPDATE_ORDERS_BEGIN:
    case POST_UPDATE_ORDERS_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case POST_PROCESS_DOCUMET_ERROR:
    case GET_DOCUMENT_BY_ID_ERROR:
    case GET_LOG_BY_DOCUMENT_ID_ERROR:
    case GET_PDF_BY_DOCUMENT_ID_ERROR:
    case POST_REVALIDATE_DOCUMENT_ERROR:
    case PATCH_REVALIDATED_DOCUMENT_CHANGE_IS_LOCKED_ERROR:
    case GET_ALLOWED_DOCUMENT_TYPES_ERROR:
    case GET_DOCUMENT_ORDERS_ERROR:
    case GET_DOCUMENT_ORDERS_BY_IDS_ERROR:
    case POST_UPDATE_ORDERS_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export { aiReducer };
